<template>
  <div class="details room">
    <table>
      <tbody v-if="Object.keys(room).length">
        <tr v-if="room.short_name">
          <td>{{ _.short_name }}</td>
          <td>{{ room.short_name }}</td>
        </tr>
        <tr>
          <td>{{ _.name }}</td>
          <td>{{ room['name_' + language] }}</td>
        </tr>
        <tr v-if="room.content && room.content.capacity">
          <td>{{ _.capacity }}</td>
          <td>{{ room.content.capacity }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { API_URL } from '@/config'
import { mapGetters } from 'vuex'
export default {
  props: ['id'],
  data() {
    return {
      room: {},
    }
  },
  computed: {
    ...mapGetters(['details']),
  },
  async created() {
    const room = await this.axios.get(API_URL + '/rooms/' + this.id);
    this.setProgress(false);
    this.room = room.data;
  }
}
</script>

<style lang="scss">
.details.room {
  // padding: 12px;
  > table {
    > tbody {
      > tr {
        td:first-child {
          width: 120px;
        }
        td:not(:first-child) {
          font-weight: bold;
        }
      }
    }
  }
}
</style>
